const actionType = {
    GET_ALL_TRADES_SUCCESS: 'GET_ALL_TRADES_SUCCESS',
    SET_ATTACHMENTS: 'SET_ATTACHMENTS',
    SET_TRADE_FORM_PROPS: 'SET_TRADE_FORM_PROPS',
    SET_CHILD_FORM_PROPS: 'SET_CHILD_FORM_PROPS',
};
export default actionType;